import { PayloadAction } from "@reduxjs/toolkit";
import { AlertHelper } from "helpers";
import { EAlertType } from "helpers/alertHelper";
import {
  ICreateZoneRequest,
  ICreateZoneResponse,
  IDeleteByIdRequest,
  IDeleteZoneResponse,
  IGetAllZoneLinesResponse,
  IGetAllZonesResponse,
  IGetByIdRequest,
  IGetZoneByIdResponse,
  IGetZoneLineRequest,
  IPaginationRequest,
  IUpdateZoneRequest,
} from "model";
import { IErrorResponse } from "model/Common/IErrorResponse";
import { call, put, takeEvery } from "redux-saga/effects";
import { ZoneActions } from "redux/actions";
import { ZoneApiService } from "services";

function* getAllZones(action: PayloadAction<IPaginationRequest>) {
  try {
    const result: IGetAllZonesResponse = yield call(
      ZoneApiService.getAllZones,
      action.payload
    );
    if (result.succeeded) {
      yield put(ZoneActions.getAllZones.success(result));
    } else {
      const error = result as IErrorResponse;
      yield put(ZoneActions.getAllZones.failed(error));
    }
  } catch (error) {
    yield put(ZoneActions.getAllZones.failed(error));
  }
}
function* getAllZoneLines(action: PayloadAction<IGetZoneLineRequest>) {
  try {
    const result: IGetAllZoneLinesResponse = yield call(
      ZoneApiService.getAllZoneLines,
      action.payload
    );
    if (result.succeeded) {
      yield put(ZoneActions.getAllZoneLines.success(result));
    } else {
      const error = result as IErrorResponse;
      yield put(ZoneActions.getAllZoneLines.failed(error));
    }
  } catch (error) {
    yield put(ZoneActions.getAllZoneLines.failed(error));
  }
}
function* getZoneById(action: PayloadAction<IGetByIdRequest>) {
  try {
    const result: IGetZoneByIdResponse = yield call(
      ZoneApiService.getZoneById,
      action.payload
    );
    if (result.succeeded) {
      yield put(ZoneActions.getZoneById.success(result.data!));
    } else {
      const error = result as IErrorResponse;
      yield put(ZoneActions.getZoneById.failed(error));
    }
  } catch (error) {
    yield put(ZoneActions.getZoneById.failed(error));
  }
}

function* createZone(action: PayloadAction<ICreateZoneRequest>) {
  try {
    const result: ICreateZoneResponse = yield call(
      ZoneApiService.createZone,
      action.payload
    );
    if (result.succeeded) {
      yield put(ZoneActions.createZone.success(result.data!));
      AlertHelper.showAlert("Create Successfully", EAlertType.SUCCESS);
    } else {
      const error = result as IErrorResponse;
      yield put(ZoneActions.createZone.failed(error));
    }
  } catch (error) {
    yield put(ZoneActions.createZone.failed(error));
  }
}

function* updateZone(action: PayloadAction<IUpdateZoneRequest>) {
  try {
    const result: ICreateZoneResponse = yield call(
      ZoneApiService.updateZone,
      action.payload
    );
    if (result.succeeded) {
      yield put(ZoneActions.updateZone.success(result.data!));
      AlertHelper.showAlert("Update Successfully", EAlertType.SUCCESS);
    } else {
      const error = result as IErrorResponse;
      yield put(ZoneActions.updateZone.failed(error));
    }
  } catch (error) {
    yield put(ZoneActions.updateZone.failed(error));
  }
}
function* deleteZone(action: PayloadAction<IDeleteByIdRequest>) {
  try {
    const result: IDeleteZoneResponse = yield call(
      ZoneApiService.deleteZone,
      action.payload
    );
    if (result.succeeded) {
      yield put(ZoneActions.deleteZone.success(result.data!));
      AlertHelper.showAlert("Delete Successfully", EAlertType.SUCCESS);
    } else {
      const error = result as IErrorResponse;
      yield put(ZoneActions.deleteZone.failed(error));
    }
  } catch (error) {
    yield put(ZoneActions.deleteZone.failed(error));
  }
}

export function* Watcher() {
  yield takeEvery(ZoneActions.getAllZones.request, getAllZones);
  yield takeEvery(ZoneActions.getZoneById.request, getZoneById);
  yield takeEvery(ZoneActions.createZone.request, createZone);
  yield takeEvery(ZoneActions.updateZone.request, updateZone);
  yield takeEvery(ZoneActions.deleteZone.request, deleteZone);
  yield takeEvery(ZoneActions.getAllZoneLines.request, getAllZoneLines);
}
